import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/layout/Layout';
import ScrollToTop from './components/common/ScrollToTop';
import HomePage from './pages/HomePage';
import PrinciplesPage from './pages/PrinciplesPage';
import ApproachPage from './pages/ApproachPage';
import HistoryPage from './pages/HistoryPage';
import ContactPage from './pages/ContactPage';
import './styles/index.css';

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/principles" element={<PrinciplesPage />} />
          <Route path="/approach" element={<ApproachPage />} />
          <Route path="/history" element={<HistoryPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/method" element={<Navigate to="/approach" replace />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;